import React from "react";

const ServicesSection: React.FC = () => {
    return (
        <section className="w-full bg-white">
            <div className="px-6 md:px-8 bg-[#F6F7F9] rounded-3xl">
                {/* Wrapper con fondo y bordes redondeados */}
                <div className="mx-auto max-w-7xl px-6 py-10 md:px-10 md:py-14 shadow-sm">
                    {/* Badge */}
                    <div className="mb-6 flex justify-center">
                        <span className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm text-slate-700 shadow-sm">
                            <img src="/icons/services.svg" alt="Servicios" className="h-4 w-4" />
                            Servicios
                        </span>
                    </div>

                    {/* Título */}
                    <h2 className="text-center text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
                        Servicios que resuelven problemas reales
                    </h2>

                    {/* Grid */}
                    <div className="mt-10 flex flex-col gap-6 md:mt-12">


                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {/* Asistentes con IA */}
                            <article className="overflow-hidden rounded-3xl bg-[#F6F7F9] border border-white shadow-sm ring-1 ring-slate-100 transition-all duration-300 hover:shadow-2xl hover:-translate-y-1" style={{ borderWidth: '15px' }}>
                                <img
                                    src="./api_ia.png"
                                    alt="Asistentes con IA"
                                    className="mb-4 w-full rounded-lg"
                                />
                                <div className="p-6">
                                    <h3 className="text-lg font-semibold text-slate-900">
                                        Asistentes con inteligencia artificial
                                    </h3>
                                    <p className="mt-2 text-slate-600">
                                        Integrados a tus procesos para potenciar decisiones,
                                        responder consultas y optimizar flujos.
                                    </p>
                                </div>
                            </article>

                            {/* Páginas web profesionales */}
                            <article className="overflow-hidden rounded-3xl bg-[#F6F7F9] border border-white shadow-sm ring-1 ring-slate-100 transition-all duration-300 hover:shadow-2xl hover:-translate-y-1" style={{ borderWidth: '15px' }}>
                                <img
                                    src="./api_website.png"
                                    alt="Páginas web profesionales"
                                    className="mb-4 w-full rounded-lg"
                                />
                                <div className="p-6">
                                    <h3 className="text-lg font-semibold text-slate-900">
                                        Páginas web profesionales
                                    </h3>
                                    <p className="mt-2 text-slate-600">
                                        Diseñadas a tu medida, adaptables a tu marca y
                                        necesidades de negocio.
                                    </p>
                                </div>
                            </article>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {/* Apps móviles */}
                            <article className="overflow-hidden rounded-3xl bg-[#F6F7F9] border border-white shadow-sm ring-1 ring-slate-100 transition-all duration-300 hover:shadow-2xl hover:-translate-y-1" style={{ borderWidth: '15px' }}>
                                <img
                                    src="./api_iPhone_Pro_hero.png"
                                    alt="Aplicaciones móviles"
                                    className="mb-4 w-full rounded-lg"
                                />
                                <div className="p-6">
                                    <h3 className="text-lg font-semibold text-slate-900">
                                        Aplicaciones móviles personalizadas
                                    </h3>
                                    <p className="mt-2 text-slate-600">
                                        Conecta mejor con tus usuarios desde cualquier
                                        dispositivo con apps seguras y escalables.
                                    </p>
                                </div>
                            </article>

                            {/* Automatización */}
                            <article className="overflow-hidden rounded-3xl bg-[#F6F7F9] border border-white shadow-sm ring-1 ring-slate-100 transition-all duration-300 hover:shadow-2xl hover:-translate-y-1" style={{ borderWidth: '15px' }}>
                                <img
                                    src="./api_process.png"
                                    alt="Automatización de procesos"
                                    className="mb-4 w-full rounded-lg"
                                />
                                <div className="p-6">
                                    <h3 className="text-lg font-semibold text-slate-900">
                                        Automatización de procesos corporativos
                                    </h3>
                                    <p className="mt-2 text-slate-600">
                                        Optimiza tiempos y reduce errores con flujos
                                        automatizados y eficientes.
                                    </p>
                                </div>
                            </article>

                            {/* Mantenimiento */}
                            <article className="overflow-hidden rounded-3xl bg-[#F6F7F9] border border-white shadow-sm ring-1 ring-slate-100 transition-all duration-300 hover:shadow-2xl hover:-translate-y-1" style={{ borderWidth: '15px' }}>
                                <img
                                    src="./api_support.png"
                                    alt="Mantenimiento y soporte"
                                    className="mb-4 w-full rounded-lg"
                                />
                                <div className="p-6">
                                    <h3 className="text-lg font-semibold text-slate-900">
                                        Mantenimiento y soporte tecnológico
                                    </h3>
                                    <p className="mt-2 text-slate-600">
                                        Aseguramos que tu infraestructura opere sin detenerse
                                        y con rendimiento óptimo.
                                    </p>
                                </div>
                            </article>
                        </div>

                        {/* Card grande (ancho completo) */}
                        <article className="group relative overflow-hidden rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-100 transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 md:col-span-2 lg:col-span-3">
                            <div className="grid items-center gap-6 md:grid-cols-2 bg-[#F6F7F9] rounded-3xl">
                                <div className="p-6">
                                    <h3 className="text-3xl font-bold text-slate-900">
                                        Integración de servicios LEXIS vía API
                                    </h3>
                                    <p className="mt-2 text-slate-600">
                                        Conecta nuestras soluciones directamente en tus
                                        plataformas institucionales o sistemas existentes
                                        para optimizar tus procesos.
                                    </p>
                                </div>
                                <div className="relative flex justify-end">
                                    {/* Reemplaza rutas por tus imágenes en /public */}
                                    <img
                                        src="./api_services.png"
                                        alt="Integración vía API"
                                        className="w-full max-w-md rounded-xl ml-auto"
                                    />
                                </div>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServicesSection;
